import { TBulkCountAppDBStore } from '@monorepo/types';
import {
  INITIAL_CACHE_RESET_TIMESTAMP,
  WAITING_TIME_FOR_NEXT_EVENTS_SYNCING_IN_MILLI_SECONDS,
} from '../metadata/metadata.reducer';
import { BulkCountAppDBActionTypes, TBulkCountAppActions } from './bulk-count-app-db.action';
import produce from 'immer';
import { BCTXComputationHelper } from '@monorepo/utils';

export function getBulkCountAppInitialState(nextCacheResetTimestamp: number) {
  const bulkCountAppInitialState: TBulkCountAppDBStore = {
    userDBLockDetails: {
      isLocked: false,
      lockedBy: 'NONE',
    },
    userDB: {
      dailyCache: {
        lastStyleSyncInfoTimestamp: undefined,
        nextCacheResetTimestamp: nextCacheResetTimestamp,
        lineMap: {},
        events: {
          list: [],
        },
        totalCount: 0,
      },
      persistanceCache: {
        pendingTransactions: [],
      },
    },
    bgDB: {
      dailyCache: {
        totalCount: 0,
        nextCacheResetTimestamp,
        lineMap: {},
        events: {
          list: [],
        },
      },
      persistanceCache: {
        pastDaysList: [],
      },
    },
    bgDBLockDetails: {
      isLocked: false,
      lockedBy: 'NONE',
      metadata: {
        SYNC_EVENTS: {},
      },
    },
    vendors: {
      isDefaultVendor: false,
      factoryId: '',
      vendors: [],
    },
    transactions: {
      type: 'SEND',
      res: {
        transactions: [],
        supportedFilters: [],
        selectedFilters: [],
      },
    },
  };
  return bulkCountAppInitialState;
}

export const bulkCountAppInitialState: TBulkCountAppDBStore =
  getBulkCountAppInitialState(INITIAL_CACHE_RESET_TIMESTAMP);

export function BulkCountAppDBReducer(
  state: TBulkCountAppDBStore = bulkCountAppInitialState,
  action: TBulkCountAppActions,
): TBulkCountAppDBStore {
  switch (action.type) {
    case BulkCountAppDBActionTypes.SetUserDBAndBackgoundDBAndReleaseLock:
    case BulkCountAppDBActionTypes.SetUserAndBgDBAndReleaseLockAndThenAcquireLockAndThenSyncStyleInfo:
    case BulkCountAppDBActionTypes.SetUserDBAndBgDBAndReleaseLocksWithChainsForWashing:
    case BulkCountAppDBActionTypes.SetUserAndBgDBAndReleaseLockAndThenAcquireLockAndThenSyncReceiveCount: {
      return produce(state, (draft) => {
        draft.userDB = action.userActualDB;
        draft.bgDB = action.backgroundDB;
        draft.userDBLockDetails = BCTXComputationHelper.releaseUserDBLock(draft.userDBLockDetails);
        draft.bgDBLockDetails = BCTXComputationHelper.releaseBgLock(draft.bgDBLockDetails);
      });
    }
    case BulkCountAppDBActionTypes.UpdateUserDBAndSyncSendCountAndThenReleaseLock:
    case BulkCountAppDBActionTypes.UpdateUserDBAndSyncBctxWiseSentQuantityAndThenReleaseLock:
    case BulkCountAppDBActionTypes.UpdatedUserDBAndSyncBctxWiseWipQuantityAndThenReleaseLock:
    case BulkCountAppDBActionTypes.UpdateUserDBAndSyncVendorsToBctxCombinationDataAndThenReleaseLock: {
      return {
        ...state,
        userDB: action.currentDB,
      };
    }
    case BulkCountAppDBActionTypes.SetInitialVendorsDBAndSyncVendors:
    case BulkCountAppDBActionTypes.UpdateVendorsDetails:
      return produce(state, (draft) => {
        draft.vendors = action.res;
      });
    case BulkCountAppDBActionTypes.UpdateUserDBAndReleaseLockAndThenRedirectToLandingPage:
    case BulkCountAppDBActionTypes.UpdateUserDBAndReleaseLock:
    case BulkCountAppDBActionTypes.UpdateUserDBAndReleaseLockAndSynEventsAndRedirectToLandingPage:
      return produce(state, (draft) => {
        draft.userDBLockDetails = BCTXComputationHelper.releaseUserDBLock(draft.userDBLockDetails);
        draft.userDB = action.currentDB;
      });
    case BulkCountAppDBActionTypes.UpdateLockDetails: {
      return produce(state, (draft) => {
        draft.userDBLockDetails = action.lockDetails;
      });
    }
    case BulkCountAppDBActionTypes.ReleaseUserDBLock: {
      return produce(state, (draft) => {
        draft.userDBLockDetails = BCTXComputationHelper.releaseUserDBLock(draft.userDBLockDetails);
      });
    }
    case BulkCountAppDBActionTypes.ReleaseBgDBLock: {
      return produce(state, (draft) => {
        draft.bgDBLockDetails = BCTXComputationHelper.releaseBgLock(draft.bgDBLockDetails);
      });
    }
    case BulkCountAppDBActionTypes.UpdateBgDBLockDetails: {
      return produce(state, (draft) => {
        draft.bgDBLockDetails = action.lockDetails;
      });
    }
    case BulkCountAppDBActionTypes.SyncTransactionsSuccessAndThenReleaseLock: {
      return produce(state, (draft) => {
        draft.userDBLockDetails = BCTXComputationHelper.releaseUserDBLock(draft.userDBLockDetails);
        draft.transactions = action.res;
      });
    }
    case BulkCountAppDBActionTypes.UpdateBgDBAndReleaseLockForSyncEvents: {
      const currentTime = new Date().getTime();
      return produce(state, (draft) => {
        draft.bgDB = action.currentDB;
        draft.bgDBLockDetails = BCTXComputationHelper.releaseBgLock(
          draft.bgDBLockDetails,
          action.syncEventsDTO.lastBatchSyncStatus === 'SERVER_ERROR'
            ? WAITING_TIME_FOR_NEXT_EVENTS_SYNCING_IN_MILLI_SECONDS + currentTime
            : undefined,
        );
      });
    }
    default:
      return state;
  }
}
